export default {"src":"/_next/static/media/review-source-vrbo.cf49ee09.svg","height":19,"width":59};